// Description: Constants used to map statuses from user org statuses API call to table progress bars.
export const adRequestStatusMap = {
  "Not-Requested": "Non-Member",
  Requested: "In-Progress",
  Joined: "Joined",
  Failed: "Failed",
  Pending: "Pending",
  Rejected: "Rejected",
  "Remove-Requested": "Removed",
  Removed: "Removed",
};

export const TOKEN_VALIDITY_DAYS_UPPER_LIMIT = 360;
export const TOKEN_VALIDITY_DAYS_LOWER_LIMIT = 90;
export const TOKEN_VALIDITY_DAYS_DEFAULT = 180;

export const TOKEN_INACTIVITY_DAYS_UPPER_LIMIT = 90;
export const TOKEN_INACTIVITY_DAYS_LOWER_LIMIT = 30;
export const TOKEN_INACTIVITY_DAYS_DEFAULT = 45;

export const SIGNUP_BANNER_DEFAULT = "No description available";

export const REASON_COLUMN_CHARACTER_TRUNCATE_LIMIT = 50;
export const EMAIL_COLUMN_CHARACTER_TRUNCATE_LIMIT_OWNER_VIEW = 28;
export const EMAIL_COLUMN_CHARACTER_TRUNCATE_LIMIT_APPROVER_VIEW = 35;

// Tier names are fixed (not editable by org owners) — only the min/max range
// and auto-approve flag are configurable per org. Each tier's min is derived
// as the previous tier's max + 1, so ranges always stay contiguous.
export const BUDGET_TIERS_DEFAULT = [
  { name: "Tier 1", min: 1, max: 100, autoApprove: false },
  { name: "Tier 2", min: 101, max: 200, autoApprove: false },
  { name: "Tier 3", min: 201, max: 300, autoApprove: false },
  { name: "Tier 4", min: 301, max: 400, autoApprove: false },
];

export const INACTIVE_LOGOUT_TIMER_EVENTS = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];
export const INACTIVE_LOGOUT_TIMER_DURATION = 1800000;
